import ApiService from './api.service'
import { TokenService } from './storage.service'

const ItemSearchService = {
    searchItemAdvanced: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemSearch/SearchItemAdvanced',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    searchItemByNumber: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemSearch/SearchItemByNumber',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    searchItemByCatalogNumber: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemSearch/SearchItemByCatalogNumber',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
    searchItemPrices: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/ItemSearch/SearchItemPrices',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    }
}

export default ItemSearchService